(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers', [
            'services.esbEmployees',
            'services.env',
            'gov.filters',
            'gov.services',
            'gov.directives'
        ]);
})();
